var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "About IST",
      "tabActive": "Partners",
      "bg": "/images/sub/visual/sv1.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Partners ")])]), _c('top-image', {
    attrs: {
      "src": "/images/sub/about/partner/partner-img.png"
    }
  })], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "my-n10 ma-lg-n30"
  }, [_c('partner', {
    attrs: {
      "company": "SK Hynix",
      "src": "/images/sub/about/partner/logo1.png",
      "width": "96"
    }
  }), _c('partner', {
    attrs: {
      "company": "EBARA in Korea",
      "src": "/images/sub/about/partner/logo2.png",
      "width": "177"
    }
  }), _c('partner', {
    attrs: {
      "company": "DUPONT KALREZ",
      "src": "/images/logos/kalrez.png",
      "width": "290",
      "dupont": ""
    }
  }), _c('partner', {
    attrs: {
      "company": "KCTech",
      "src": "/images/sub/about/partner/logo4.png",
      "width": "249"
    }
  }), _c('partner', {
    attrs: {
      "company": "EHWA DIAMOND",
      "src": "/images/sub/about/partner/logo5.png",
      "width": "177"
    }
  }), _c('partner', {
    attrs: {
      "company": "DUPONT VESPEL",
      "src": "/images/logos/vespel.png",
      "width": "270",
      "dupont": ""
    }
  }), _c('partner', {
    attrs: {
      "company": "ENDO - MFG",
      "src": "/images/sub/about/partner/logo7.png",
      "width": "175"
    }
  }), _c('partner', {
    attrs: {
      "company": "Mitsubishi Cable Industries",
      "src": "/images/sub/about/partner/logo6.png",
      "width": "359"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }